import wixData from 'wix-data';

$w.onReady(function () {
	$w('#repeater1').onItemReady(($item, itemData, index) => {

		//link title
		//$item("#titleText").html = "<a target='_blank' href='http://www.wcsj2019.eu" + itemData["sessionsTitle"] + "'><h4>" + itemData.title + "</h4></a>"
		$item("#titleText").html = "<a target='_blank' href='http://www.wcsj2019.eu" + itemData["link-Sessions-title"] + "'><h4>" + itemData.title + "</h4></a>"

		// se c'è almeno un nome il button CREW viene mostrato
		wixData.query("Sessions")
			.include("organizer")
			.eq("code", itemData.code)
			.find()
			.then((result) => {
				var org = result.items[0].organizer1.length;
				if (org !== 0) {
					$item("#crewButton").show();
				}
			})
			
		wixData.query("Sessions")
			.include("moderator")
			.eq("code", itemData.code)
			.find()
			.then((result) => {
				var mod = result.items[0].moderator.length;
				if (mod !== 0) {
					$item("#crewButton").show();
				}
			})
		wixData.query("Sessions")
			.include("speaker")
			.eq("code", itemData.code)
			.find().then((result) => {
				var spe = result.items[0].speaker.length;
				if (spe !== 0) {
					$item("#crewButton").show();
				}
			})


		//box crew
		var collapsed = true;
		$item("#crewButton").onClick(() => {
			if (collapsed) {
			//  TABELLA ORGANIZERS
				wixData.query("Sessions").include("organizer").eq("code", itemData.code).find().then((result) => {
					let organizers = result.items[0].organizer;
					var tableData = [];
					var tableColumns = [
						{
    						"id": "thumb",
						    "label": "Thumb",
 						    "width": 45,
    						"type": "image",
   							"dataPath": "thumb",
						    "visible": true,
						},
						{
    						"id": "name",
						    "label": "Name",
 						    "width": 200,
    						"type": "richText",
							"dataPath": "name",
						    "visible": true,
						}
					];
					organizers.forEach((item) => {
						tableData.push({
							'thumb': item.thumb,
							'name': "<a href='" + item['link-Speakers-title'] + "' target='_blank'>" + item.name + "</a>",
						});
					});

					//nascondi tabella se vuota
					if(tableData.length === 0){
						$item("#table1").hide();
						$item("#table1").collapse();
						//eventualmente aggiugere stringa "nessun dato da mostrare" o simile
					}
					//singolare plurale
					if(tableData.length === 1)
						$item("#text58").text = "ORGANIZER";
					else
						$item("#text58").text = "ORGANIZERS";

					$item("#table1").columns = tableColumns;
					$item("#table1").rows = tableData;
				});

			//  TABELLA MODERATORS	
				wixData.query("Sessions").include("moderator").eq("code", itemData.code).find().then((result) => {
					let moderators = result.items[0].moderator;
					var tableData = [];
					var tableColumns = [
						{
    						"id": "thumb",
						    "label": "Thumb",
 						    "width": 45,
    						"type": "image",
   							"dataPath": "thumb",
						    "visible": true,
						},
						{
    						"id": "name",
						    "label": "Name",
 						    "width": 200,
    						"type": "richText",
							"dataPath": "name",
						    "visible": true,
						}
					];
					moderators.forEach((item) => {
						tableData.push({
							'thumb': item.thumb,
							'name': "<a href='" + item['link-Speakers-title'] + "' target='_blank'>" + item.name + "</a>",
						});
					});

					//nascondi tabella se vuota
					if(tableData.length === 0){
						$item("#table2").hide();
						$item("#table2").collapse();
						//eventualmente aggiugere stringa "nessun dato da mostrare" o simile
					}
					//singolare plurale
					if(tableData.length === 1)
						$item("#text59").text = "MODERATOR";
					else
						$item("#text59").text = "MODERATORS";

					$item("#table2").columns = tableColumns;
					$item("#table2").rows = tableData;
				});

			//  TABELLA SPEAKERS
				wixData.query("Sessions").include("speaker").eq("code", itemData.code).find().then((result) => {
					let speakers = result.items[0].speaker;
					var tableData = [];
					var tableColumns = [
						{
    						"id": "thumb",
						    "label": "Thumb",
 						    "width": 45,
    						"type": "image",
   							"dataPath": "thumb",
						    "visible": true,
						},
						{
    						"id": "name",
						    "label": "Name",
 						    "width": 200,
    						"type": "richText",
							"dataPath": "name",
						    "visible": true,
						}
					];
					speakers.forEach((item) => {
						tableData.push({
							'thumb': item.thumb,
							'name': "<a href='" + item['link-Speakers-title'] + "' target='_blank'>" + item.name + "</a>",
						});
					});

					//nascondi tabella se vuota
					if(tableData.length === 0){
						$item("#table3").hide();
						$item("#table3").collapse();
						//eventualmente aggiugere stringa "nessun dato da mostrare" o simile
					}
					//singolare plurale
					if(tableData.length === 1)
						$item("#text60").text = "SPEAKER";
					else
						$item("#text60").text = "SPEAKERS";

					$item("#table3").columns = tableColumns;
					$item("#table3").rows = tableData;
				});

			$item("#box1").show();
			$item("#box1").expand();
			collapsed = false;
				} else {
					$item("#box1").hide();
					$item("#box1").collapse();
					collapsed = true;
					}
		});

	});
});